module.exports = __webpack_public_path__ + "static/bg-sec12-db05ecc3975926bf4d5f54dc33443f28.jpg";